import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight, ShieldCheck } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

export default function LegalHub() {
  const { t } = useLanguage();
  const page = t.legalHubPage;

  return (
    <div className="bg-white" data-testid="legal-hub-page">
      {/* Hero */}
      <section className="grain-texture" style={{ background: "var(--brand-primary)", color: "#fff" }}>
        <div className="container-brand py-14 md:py-20">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm font-display font-medium opacity-90 hover:opacity-100 transition-opacity"
            data-testid="back-to-home"
          >
            <ArrowLeft size={16} /> {t.common.backToHome}
          </Link>
          <p
            className="mt-7 text-[11px] font-display font-semibold uppercase tracking-[0.18em] inline-block px-3 py-1 rounded-full"
            style={{ background: "var(--brand-accent)", color: "#000" }}
          >
            {page.eyebrow}
          </p>
          <h1
            className="mt-5 font-display font-bold text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight"
            style={{ color: "#fff" }}
          >
            {page.title}
          </h1>
          <p className="mt-5 max-w-3xl text-base sm:text-lg opacity-90 leading-relaxed">
            {page.intro}
          </p>
          <div className="mt-6 text-sm opacity-80">
            {t.common.lastUpdated}: <strong className="opacity-100">{t.common.lastUpdatedDate}</strong>
          </div>
        </div>
      </section>

      {/* Cards grid */}
      <section className="container-brand py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {page.sections.map((s) => (
            <Link
              key={s.id}
              to={s.link}
              data-testid={`legal-card-${s.id}`}
              className="group rounded-2xl bg-white p-6 border flex flex-col transition-all duration-200 hover:-translate-y-[3px]"
              style={{
                borderColor: "var(--brand-border-soft)",
                boxShadow: "var(--brand-shadow-card)",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.boxShadow = "var(--brand-shadow-floating)")}
              onMouseLeave={(e) => (e.currentTarget.style.boxShadow = "var(--brand-shadow-card)")}
            >
              <span
                className="inline-flex items-center justify-center w-11 h-11 rounded-xl"
                style={{ background: "var(--brand-accent)", color: "#000" }}
              >
                <ShieldCheck size={20} />
              </span>
              <h3 className="mt-5 font-display font-bold text-lg text-[color:var(--brand-primary)] leading-tight">
                {s.title}
              </h3>
              <p className="mt-2 text-sm text-[#3a4659] leading-relaxed flex-1">{s.body}</p>
              <span className="mt-5 inline-flex items-center gap-1.5 text-xs font-display font-semibold text-[color:var(--brand-primary)]">
                {t.common.readDocument}
                <ArrowRight
                  size={14}
                  className="transition-transform duration-200 group-hover:translate-x-0.5"
                />
              </span>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
